import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageEdit"><Path d="M8 3H3V21H12V16.4241L16.3787 12.0454C17.6296 10.7945 19.4159 10.4053 21 10.8778V3H16V9H8V3Z" fill="currentColor"/><Path d="M14 3H10V7H14V3Z" fill="currentColor"/><Path d="M21.5404 13.4596C20.5056 12.4248 18.8278 12.4248 17.7929 13.4596L14 17.2525V21.0001H17.7475L21.5404 17.2072C22.5753 16.1723 22.5753 14.4945 21.5404 13.4596Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageEdit;
